type PaymentTypesProps = {
  paymentMethods: string[];
};

const PaymentTypes = ({ paymentMethods }: PaymentTypesProps) => {
  const paymentMethodsLower = paymentMethods.map((pm) => pm.toLowerCase());

  return (
    <section className="product-securepayment">
      <h3>Sicher bezahlen:</h3>
      <ul>
        {paymentMethodsLower.includes('creditcard') && (
          <>
            <li>
              <img
                alt="Logo Zahlungsanbieter Mastercard"
                loading="lazy"
                src="/paymenticons/mastercard.svg"
                title="Mastercard"
              />
            </li>
            <li>
              <img
                alt="Logo Zahlungsanbieter Visa"
                loading="lazy"
                src="/paymenticons/visa.svg"
                title="Visa"
              />
            </li>
          </>
        )}
        {paymentMethodsLower.includes('paypal') && (
          <li>
            <img
              alt="Logo Zahlungsanbieter PayPal"
              loading="lazy"
              src="/paymenticons/paypal.svg"
              title="PayPal"
            />
          </li>
        )}
        {paymentMethodsLower.includes('sofort') && (
          <li>
            <img
              alt="Logo Zahlungsanbieter Klarna Sofortüberweisung"
              loading="lazy"
              src="/paymenticons/klarna.svg"
              title="Klarna Sofortüberweisung"
            />
          </li>
        )}
        {paymentMethodsLower.includes('directdebit') && paymentMethodsLower.includes('sepa') && (
          <li>
            <img
              alt="Logo Zahlungsanbieter SEPA"
              loading="lazy"
              src="/paymenticons/sepa.svg"
              title="SEPA"
            />
          </li>
        )}
      </ul>
    </section>
  );
};

export { PaymentTypes };
